// Nav holds gId/sId/cId as both strings and numbers, and RTDB `equalTo` matches on type, so a
// string query never sees a numeric row and the importer stores a second copy.
export default class ThirdPartyIdUtil {
  static queryCandidates(id: any): (string | number)[] {
    if (id === null || id === undefined || id === "") {
      return [];
    }

    const asString = String(id);
    const candidates: (string | number)[] = [asString];

    // The round-trip rules out leading zeros and anything past the safe-integer range.
    const asNumber = Number(asString);
    if (Number.isSafeInteger(asNumber) && String(asNumber) === asString) {
      candidates.push(asNumber);
    }

    return candidates;
  }

  // Nil passes through: cleanActivityDb drops the key for a non third-party activity.
  static normalise(id: any): any {
    return id === null || id === undefined ? id : String(id);
  }

  // Oldest wins so re-imports converge on the original instead of forking again.
  static pickOriginal(matches: any[]): any {
    return matches.filter((match) => match).sort((a, b) => (a.dS ?? 0) - (b.dS ?? 0) || (a.lmd ?? 0) - (b.lmd ?? 0))[0];
  }
}
